import { LatLngTuple } from 'leaflet';
import {
  addressResponseType,
  getCoordinates,
  getNearestAsset,
  getWithinBoundaryCheck,
} from '../mapUtils';
import { Map } from 'leaflet';
import { AssetConfig, AssetType, AssetTypeConfig } from '@types';
import * as Sentry from '@sentry/react';
import { booleanPointInPolygon, polygon } from '@turf/turf';

export const isMapCorrectZoomLevel = (map: Map) => map.getZoom() > 16;

export const isCoordinatesInsideBorough = async (coordinates: LatLngTuple) => {
  const isInside = await getWithinBoundaryCheck(coordinates[0], coordinates[1]);
  return isInside;
};

export const containsAddressFilterItem = (address: string) => {
  const addressLookupFilter = [
    'PAY PHONE',
    'PAYPHONE',
    'BUS STOP',
    'BUS SHELTER',
    'BUS SHELTERS',
  ];
  return addressLookupFilter.find((filterItem) => address.includes(filterItem));
};

export const isWithinTfLBoundary = async (
  address: addressResponseType,
  assetType: AssetTypeConfig[] | AssetTypeConfig,
): Promise<boolean> => {
  if (address.latitude && address.longitude) {
    try {
      // const assetString = Array.isArray(assetType) ? assetType[0] : assetType;
      const assetString =
        typeof (assetType as AssetType)[0] === 'string'
          ? assetType
          : (assetType as AssetConfig[])[0].asset;
      const asset = await getNearestAsset(
        Number.parseFloat(address.latitude),
        Number.parseFloat(address.longitude),
        assetString as AssetType,
        true,
      );
      if (asset?.within_tfl_boundary) {
        return true;
      }
    } catch (error) {
      Sentry.captureException(error);
      return false;
    }
  }
  return false;
};

export const isLatLngWithinBoundary = (
  lat: number,
  lng: number,
  enableBuffer?: boolean,
) => {
  let coordinates: number[][][] | undefined = getCoordinates(enableBuffer);

  if (!coordinates) {
    throw new Error('Not able to find coordinates');
  }

  return booleanPointInPolygon([lng, lat], polygon(coordinates));
};
